import $ from 'jquery';

const ACTIVE_CLASS = 'is-active';

$(document).ready(() => {
  const $header = $('.js-fixed-header');
  const SHRUNK = 'is-shrunk';
  let winWidth = $(window).outerWidth();

  window.onscroll = () => {
    if (winWidth > 767) {
      const top = $(window).scrollTop();
      if (top > 100) {
        $header.addClass(SHRUNK);
      } else {
        $header.removeClass(SHRUNK);
      }
    }
  };

  $(window).resize(() => {
    winWidth = $(window).outerWidth();

    if (winWidth < 768) {
      $header.removeClass(SHRUNK);
    }
  });
});

$(document).ready(() => {
  const navigation = document.querySelector('.main-nav');

  if (!navigation) {
    return;
  }

  const items = Array.from(navigation.querySelectorAll('.js-main-nav-l1'));

  items.forEach((item) => {
    const link = item.firstElementChild;

    link.addEventListener('click', (event) => {
      if (isBurgerNavigation()) {
        event.preventDefault();

        const isActive = item.classList.contains(ACTIVE_CLASS);

        items.forEach((el) => {
          el.classList.remove(ACTIVE_CLASS);
        });

        item.classList.toggle(ACTIVE_CLASS, !isActive);
      }
    });
  });
});

function isBurgerNavigation() {
  return window.matchMedia('(max-width: 1034px)').matches;
}
